import Vue from 'vue';
import {
  Card, Form, Input, Button, notification, Layout, Menu,
  Avatar, Dropdown, Icon, Spin, Table, Checkbox, Select, Badge, Modal,
  Radio, Tooltip, DatePicker, Upload, ConfigProvider, Tag,
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Api from '@/plugins/Api';
import App from './App.vue';
import router from './router';
import store from './store';

import 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';

Vue.config.productionTip = false;

Vue.use(Api);
Vue.prototype.$notification = notification;
Vue.use(Card);
Vue.use(Form);
Vue.use(Input);
Vue.use(Button);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Avatar);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Spin);
Vue.use(Table);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Badge);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Tooltip);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(ConfigProvider);
Vue.use(Tag);

Vue.mixin({
  computed: {
    rights() {
      return this.$store.getters.rights;
    },
    currentEntity() {
      return this.$store.getters.currentEntity;
    },
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
